<template>
  <div id="slider-parent-container" class="d-flex align-items-center justify-content-center">
    <button id="slider-button-previous" class="dates-slider-container__button border-0 bg-white">
      <img src="/assets/images/previous-arrow.svg" alt="previous-arrow" srcset="" data-button-action="previous" type="button" @click="handleSlidePrevious">
    </button>
    <div id="dates-slider-container" class="d-flex align-items-center" ref="datesSliderContainer">
      <div class="dates-slider-container__inner d-inline-flex" ref="sliderItems" :style="[{transform: `translate(${currentTransform}px, 0)`}]">
        <template v-for="item in listDates" :key="item.id.split('T')[0]">
          <button
              class="dates-slider-container__inner__item mx-2 d-flex flex-column"
              :class="{ 'dates-slider-container__inner__item__active': isSelectedDate.id === item.id,
                'dates-slider-container__inner__item__disabled': isDisabledDate(item.id)
              }"
              :data-slide-item="item.id"
              :disabled="isDisabledDate(item.id)"
              @click="select">
            <span
                class="dates-slider-container__inner__item__title"
                :class="{'dates-slider-container__inner__item__active__title': isSelectedDate.id === item.id}">
              {{$t(item.weekday)}}
            </span>
            <span
                class="dates-slider-container__inner__item__content"
                :class="{'dates-slider-container__inner__item__active__content': isSelectedDate.id === item.id}">
              {{$t(item.month + '_whose')}} {{item.monthDay}}
            </span>
          </button>
        </template>

      </div>
    </div>
    <button id="slider-button-next" class="dates-slider-container__button border-0 bg-white">
      <img src="/assets/images/next-arrow.svg" alt="next-arrow" srcset="" data-button-action="next" type="button" @click="handleSlideNext">
    </button>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
export default defineComponent({
  name: 'DatesSliderComponent',
  emits: ['selected-date'],
  props: {
    selectedDate: {
      type: String,
      required: true
    },
    roundTrip: {
      type: Boolean,
      required: true
    },
    howManyToLoad: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      itemWidth: 0,
      currStep: 0,
      currentTransform: 0,
      displayItems: 0,
      listDates: <{id: string, month: string, monthDay: number, weekday: string}[]>[],
    }
  },

  computed: {
    isSelectedDate() {
      return this.initDates(this.selectedDate).find(d => d.id.split('T')[0] === this.selectedDate.split('T')[0]);
    },
  },

  methods: {
    isDisabledDate(item) {
      return new Date(new Date(item).toDateString()).getTime() < Date.now();
    },

    handleSlideNext(): void {

      this.currStep++;
      this.currentTransform = -(this.currStep * this.itemWidth);

      const innerContainer = document.querySelector('.dates-slider-container__inner');
      innerContainer!.classList.add('dates-slider-container__inner__animate');

      if (this.currStep === this.listDates.length - this.displayItems) {
        this.loadAdditionalDates({action: 'push'});
      }
    },


    // TODO FIX ANIMATION WHEN SCROOLING WITH LEFT BUTTON ON NEW ITEM LOAD
    handleSlidePrevious(): void {

      const innerContainer = document.querySelector('.dates-slider-container__inner');

      if (this.currStep !== 0) {
        this.currStep--;
        this.currentTransform = -(this.currStep * this.itemWidth);
        innerContainer!.classList.add('dates-slider-container__inner__animate');
      } else {
        innerContainer!.classList.remove('dates-slider-container__inner__animate');
        this.loadAdditionalDates({action: 'unshift'});
        this.currStep = 5;
        this.currentTransform = -(this.currStep * this.itemWidth);
      }

    },

    addAdditionalDates(
        selectedDate: string,
        action: string,
        amount: number
    ): {id: string, month: string, monthDay: number, weekday: string}[] {

      const arr: {id: string, month: string, monthDay: number, weekday: string}[] = [];
      const dateFull = new Date(selectedDate.split('T')[0]);
      const direction = action === 'push' ? 1 : -1;

      for ( let i = 0; i < amount; i++ ) {
        let temp = new Date(dateFull.setDate(dateFull.getDate() + direction));

        arr[action]({
          id: temp.toISOString(),
          month: temp.toLocaleString('en-GB', {month: 'long'}),
          monthDay: temp.getDate(),
          weekday: temp.toLocaleString('en-GB', { weekday: 'long' })
        });
      }

      return arr;
    },

    loadAdditionalDates(payload: {action: string}): void {
      const temp =
          payload.action === 'push' ?
              this.addAdditionalDates(this.listDates[this.listDates.length - 1].id, payload.action, this.howManyToLoad) :
              this.addAdditionalDates(this.listDates[0].id, payload.action, this.howManyToLoad);

      this.listDates[payload.action](...temp);
    },

    initDates(selectedDate: string): {id: string, month: string, monthDay: number, weekday: string}[] {
      const selectedItem: string = new Date(selectedDate.split('T')[0]).toISOString();

      const tempDate = new Date(selectedDate.split('T')[0]);

      return [...this.addAdditionalDates(selectedItem, 'unshift', 6), {
        id: tempDate.toISOString(),
        month: tempDate.toLocaleString('en-GB', {month: 'long'}),
        monthDay: tempDate.getDate(),
        weekday: tempDate.toLocaleString('en-GB', { weekday: 'long' })
      }, ...this.addAdditionalDates(selectedItem, 'push', 6)];
    },

    select($event: Event): void {
      this.$emit('selected-date', {date: ($event.target! as HTMLDivElement).parentElement!.dataset.slideItem})
    }
  },

  created() {
    this.listDates = this.initDates(this.selectedDate);
  },

  mounted() {

    this.itemWidth = (this.$refs.sliderItems as HTMLDivElement).clientWidth / this.listDates.length;
    this.displayItems = (this.$refs.datesSliderContainer as HTMLDivElement).clientWidth / this.itemWidth;

    this.currStep = Math.ceil((this.listDates.length - this.displayItems) / 2);
    this.currentTransform = -(this.currStep * this.itemWidth);
  }
})
</script>

<style scoped lang="scss">
@import './datesSlider.scss';
</style>